import React from 'react';
import ReactDOM from 'react-dom';
import Layout from './layout/Layout';
import { BrowserRouter as Router } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './font/dana/style.css';
import './font/icomoon/style.css';
import '../node_modules/react-vis/dist/style.css';
import 'swiper/swiper.scss';
import './Template.css';

ReactDOM.render(
	<React.StrictMode>
		<Router>
			<Layout />
		</Router>
	</React.StrictMode>,
	document.getElementById('SAMSUNG')
);
